import { format, isValid, parseISO, startOfDay } from 'date-fns';
import { useQuery } from '@tanstack/react-query';

import { tariffDetailsOptions } from '../data-provider';
import type { TariffDetailsFiltersForm, TariffDetailsParams } from '../models';

const toISO = (date: Date) => format(date, "yyyy-MM-dd'T'HH:mm:ss.sss'Z'");

const toApiDateTime = (value?: string) => {
  if (!value) {
    return undefined;
  }

  const parsed = parseISO(value);
  return isValid(parsed) ? toISO(startOfDay(parsed)) : undefined;
};

export const mapTariffDetailsFilters = (
  params: TariffDetailsParams,
  filters: TariffDetailsFiltersForm,
): TariffDetailsParams => ({
  ...params,
  accountNumber: filters.accountNumber || undefined,
  class: filters.class?.id || undefined,
  effectiveDateFrom: toApiDateTime(filters.effectiveDate?.start),
  effectiveDateTo: toApiDateTime(filters.effectiveDate?.end),
  laneCode: filters.laneKey?.label || undefined,
  liner: filters.liner?.id || undefined,
  productCode: filters.productDescription || undefined,
  shipmentType: filters.shipmentType?.id || undefined,
});

export const useTariffDetails = (params: TariffDetailsParams, filters: TariffDetailsFiltersForm) => {
  return useQuery(tariffDetailsOptions(mapTariffDetailsFilters(params, filters)));
};
